export const getInitials = (name?: string) => {
  // Split on any run of whitespace — a double space ("Acme  Ltd") would
  // otherwise leave an empty part and p[0] would be undefined.
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  return parts
    .slice(0, 2)
    .map((p) => p[0].toUpperCase())
    .join("");
};

const avatarColors = [
  "#2563EB", // blue
  "#16A34A", // green
  "#DC2626", // red
  "#9333EA", // purple
  "#EA580C", // orange
  "#0D9488", // teal
  "#4F46E5", // indigo
];

export const getAvatarColor = (seed: string = "") => {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = seed.charCodeAt(i) + ((hash << 5) - hash);
  }
  return avatarColors[Math.abs(hash) % avatarColors.length];
};
